// Side nav drawer focus
// -----------------------------------------------------------------------------

export const SIDE_NAV_SETTINGS_DRAWER_TYPES = [
  "settings-general",
  "settings-theme",
  "settings-branding",
  "settings-customDomain",
  "settings-tracking",
  "settings-access",
  "settings-navigation",
  "settings-billing",
  "settings-copilot",
] as const;

export const SIDE_NAV_DRAWER_DEFAULT_OPEN_QUERY_PARAM = "sideNavDrawer";

export type SideNavSettingsType =
  (typeof SIDE_NAV_SETTINGS_DRAWER_TYPES)[number];

export const SIDE_NAV_DRAWER_TYPES = [
  "zaps",
  "integrations",
  ...SIDE_NAV_SETTINGS_DRAWER_TYPES,
] as const;

export type SideNavDrawerType = (typeof SIDE_NAV_DRAWER_TYPES)[number];

export function isSideNavDrawerType(str: string): str is SideNavDrawerType {
  return SIDE_NAV_DRAWER_TYPES.includes(str as SideNavDrawerType);
}

export type SideNavState = {
  sideNavDrawer: SideNavDrawerType;
} | null;

export type SetSideNavState = (sideNavState: SideNavState) => void;

// Utilities
// -----------------------------------------------------------------------------

export function sideNavDrawerIsFocused(
  sideNavState: SideNavState | undefined
): sideNavState is { sideNavDrawer: SideNavDrawerType } {
  return !!sideNavState;
}
